import { Shield, X } from 'lucide-react'

export interface HeaderProps {
  title?: string
  onClose?: () => void
}

export function Header({ title = 'Text Assistent', onClose }: HeaderProps) {
  return (
    <header className="flex items-center justify-between border-b border-neutral-200 px-4 py-3">
      <div className="flex items-center gap-2.5">
        <span className="flex h-8 w-8 items-center justify-center rounded-lg bg-brand-100 text-brand-700">
          <Shield className="h-5 w-5" />
        </span>
        <span className="text-base font-bold text-neutral-900">{title}</span>
      </div>
      {onClose && (
        <button
          type="button"
          onClick={onClose}
          aria-label="Schließen"
          className="flex h-7 w-7 items-center justify-center rounded-full bg-neutral-100 text-neutral-400 hover:bg-neutral-200"
        >
          <X className="h-4 w-4" />
        </button>
      )}
    </header>
  )
}
